export default "__VITE_ASSET__25925c28__"